import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const hasGrrTaggingAccess = createSelector(getScopes, scopes => scopes.includes('conversations-grr-panel'));